import React from "react";
import { ProgressBar } from "../../../components/ProgressBar";
import { PlanGoalBarProps } from "./types";

export const PlanGoalBar: React.FC<PlanGoalBarProps> = ({
  name,
  value,
  color,
}) => {
  const progressLabel = `${name} progress`;

  return (
    <ProgressBar
      value={value}
      max={100}
      color={color}
      minFillPct={2}
      ariaLabel={progressLabel}
    />
  );
};
